import backend, {FILE_STORAGE_API} from 'utils/backend/server/api_library';

const uploadFile = (body) => {
  const url = `${FILE_STORAGE_API}/upload`;
  return backend.post(url, body);
};

const downloadFile = (body) => {
  const url = `${FILE_STORAGE_API}/download`;
  return backend.post(url, body);
};

const getSecureFile = (url) => {
  return backend.get(url, false, 'blob');
};

export default {
  uploadFile,
  downloadFile,
  getSecureFile,
};
